import { Box, Typography, IconButton, useTheme} from "@mui/material";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { tokens } from "../../theme";
import Header from "../../components/global/Header";
import RemoveRedEyeOutlined from "@mui/icons-material/RemoveRedEyeOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import axios from "axios";
import { Link } from "react-router-dom";
import useFetchCredential from "../../hooks/useFetchCredential";

const UserTransactions = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {data, loading, error} = useFetchCredential(`${process.env.REACT_APP_API_URL}/transactions/get-user-transactions`);

    const approveTransaction = (id) => {
        axios.put(`${process.env.REACT_APP_API_URL}/transactions/approve-transaction/${id}`)
        .then(window.location.reload());;
    };
    const declineTransaction = (id) => {
        axios.put(`${process.env.REACT_APP_API_URL}/transactions/decline-transaction/${id}`)
        .then(window.location.reload());;
    };
    const pendTransaction = (id) => {
        axios.put(`${process.env.REACT_APP_API_URL}/transactions/pend-transaction/${id}`)
        .then(window.location.reload());;
    };

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'NGN',
    });

    const columns = [
        {
            field: "transactionID",
            headerName: "Transaction ID",
            flex: 0.7,
        },
        {
            field: "subDate",
            headerName: "Start Date",
            flex: 0.7,
            renderCell: (params) => {
                var dateString = new Date(params.row.subDate).toString();
                var splittedDateString = dateString.split(' ');
                var day = splittedDateString[0];
                var day2 = splittedDateString[1];
                var month = splittedDateString[2];
                var year = splittedDateString[3];
                var subDate = `${day}, ${day2} ${month}, ${year}`;

                return (
                <Typography>
                    { subDate }
                </Typography>
            )}
        },
        {
            field: "expiryDate",
            headerName: "Maturity Date",
            flex: 0.7,
            renderCell: (params) => {
                var dateString = new Date(params.row.expiryDate).toString();
                var splittedDateString = dateString.split(' ');
                var day = splittedDateString[0];
                var day2 = splittedDateString[1];
                var month = splittedDateString[2];
                var year = splittedDateString[3];
                var expiryDate = `${day}, ${day2} ${month}, ${year}`;

                return (
                <Typography>
                    { expiryDate }
                </Typography>
            )}
        },
        {
            field: "plan",
            headerName: "Payment For",
            flex: 1,
            renderCell: (params) => (
                <Typography
                    color= {colors.greenAccent[500]}
                >
                    { params.row.plan } Investment Plan
                </Typography>
            )
        },
        {
            field: "email",
            headerName: "Account Email",
            flex: 1,
        },
        {
            field: "name",
            headerName: "Account Name",
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "amount",
            headerName: "Trans. Amount",
            flex: 1,
            renderCell: (params) => (
                <Typography
                    color= {colors.greenAccent[500]}
                >
                    { formatter.format(params.row.amount) }
                </Typography>
            )
        },
        {
            field: "status",
            headerName: "Trans. Status",
            flex: 0.7,
            renderCell: (params) => (
                <Typography
                    color= {
                        params.row.status === "Approved" ? colors.greenAccent[500] 
                        : params.row.status === "Success" ? colors.greenAccent[500] 
                        : params.row.status === "Declined" ? colors.redAccent[500] 
                        : params.row.status === "Pending" ? colors.blueAccent[700] 
                        : colors.grey[100]
                    }
                    variant="h5"
                >
                    {params.row.status}
                </Typography>
            )
        },
        {
            headerName: "Actions",
            flex: 0.7,
            align: "left",
            renderCell: (params) => {
                return (
                    <Box
                        m="0 0 0 0"
                        p="5px 0"
                        display="flex"
                        justifyContent="space-between"
                        borderRadius = "4px"
                    >
                        
                        {/* <IconButton >
                            <RemoveRedEyeOutlined />
                        </IconButton> */}
                        <Link to={`/investment-deposit-details/${params.row.transactionID}`}>   
                            <IconButton>
                                <RemoveRedEyeOutlined sx={{color:`${colors.grey[100]} !important`}} />
                            </IconButton>
                        </Link>
                        {
                            params.row.status === "Pending" ? 
                                <IconButton onClick={() => {approveTransaction(params.row.id)}}>
                                    <CheckOutlinedIcon  />
                                </IconButton>
                            : undefined
                        }
                        {
                            params.row.status === "Pending" ? 
                                <IconButton onClick={() => {declineTransaction(params.row.id)}}>
                                    <CancelOutlinedIcon  />
                                </IconButton>
                            : undefined
                        }
                        {
                            params.row.status !== "Pending" ? 
                                <IconButton onClick={() => {pendTransaction(params.row.id)}}>
                                    <ArrowBackOutlinedIcon  />
                                </IconButton>
                            : undefined
                        }
                    </Box>
                )
            }
        },
    ]

    return <Box m="20px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Header title="USER INVESTMENT TRANSACTIONS" subtitle="List of User Transactions (Ordered By Recent)"  />
        </Box> 
        <Box
            m="30px 0 0 0"
            height="75vh"  
            sx ={{
                "& .MuiDataGrid-root": {
                    border: "none"
                },
                "& .MuiDataGrid-cell": {
                    borderBottom: "none"
                },
                "& .name-column--cell": {
                    color: colors.greenAccent[300]
                },
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: colors.blueAccent[700],
                    borderBottom: "none",
                    fontSize: "15px",
                    fontWeight: "bold"
                },
                "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: colors.primary[400]
                },
                "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: colors.blueAccent[700],
                },
                "& .MuiCheckbox-root": {
                    color: `${colors.greenAccent[200]} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[100]} !important`,
                    margin: "0 0 10px 0"
                },
                "& MuiCheckbox-root": {
                    color: `${colors.greenAccent[200]} !important`
                }
            }}
        >   
            {loading && <div style={{color:"red !important", fontSize:"30px"}}>Loading...</div>}
            {error && <div style={{color:"red !important", fontSize:"30px"}}>{error}</div>}
            {data && <DataGrid 
                    checkboxSelection
                    rows={data.sort((a, b) => b.id - a.id)}
                    columns={columns}
                    components={{Toolbar: GridToolbar}}
                    getRowId = {
                        (data) => {
                            return data.transactionID;
                        }
                    }
                />
            }
        </Box>
    </Box>
}
 
export default UserTransactions;